import ImageRotateVerify from './components/ImageRotateVerify'

/*const plugins = {
  install(Vue) {
      Vue.component(ImageRotateVerify.name, ImageRotateVerify)
  }
}*/

/*if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(ImageRotateVerify)
}*/
window.vue_plugin_image_rotate_verify = ImageRotateVerify;
/*export default plugins*/


// WEBPACK FOOTER //
// ./src/image-rotate-verify.js